import { baseURL } from "../utils/constants";
import { AdminPanelSettings } from "../utils/types";
import apiClient from "./fetch";

// Get all notifications (optionally filtered by user_id and cleared)
export const getAllNotifications = async (user_id?: string, cleared: boolean = false) => {
  try {
    const params: any = {};
    if (user_id) params.user_id = user_id;
    params.cleared = cleared;
    const response = await apiClient.get(`${baseURL}/notifications`, { params });
    return response?.data?.result || [];
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

// Get notifications count (optionally filtered by user_id and cleared)
export const getNotificationsCount = async (user_id?: string, cleared: boolean = false) => {
  try {
    const params: any = {};
    if (user_id) params.user_id = user_id;
    params.cleared = cleared;
    const response = await apiClient.get(`${baseURL}/notifications/count`, { params });
    return response?.data?.result?.count || 0;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};


// Get unreaad notifications count (optionally filtered by user_id and cleared)
export const getUnreadNotificationsCount = async (user_id?: string, cleared: boolean = false) => {
  try {
    const params: any = {};
    if (user_id) params.user_id = user_id;
    params.cleared = cleared;
    const response = await apiClient.get(`${baseURL}/notifications/unread/count`, { params });
    return response?.data?.result?.count || 0;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

// Get a single notification by ID
export const getNotification = async (notification_id: string) => {
  try {
    const response = await apiClient.get(`${baseURL}/notifications/${notification_id}`);
    return response?.data?.result;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

// Create a notification (new schema)
export const createNotification = async (notification: {
  user_id: string;
  clinic_id: string;
  type: string;
  priority?: string;
  body: string;
}) => {
  try {
    const response = await apiClient.post(`${baseURL}/notifications`, notification);
    return response?.data?.result;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

// Delete a notification
export const deleteNotification = async (notification_id: string) => {
  try {
    const response = await apiClient.delete(`${baseURL}/notifications/${notification_id}`);
    return response?.data?.result;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

// Get today's notifications for a user
export const getTodayNotifications = async (user_id: string) => {
  try {
    const response = await apiClient.get(`${baseURL}/notifications/today`, { params: { user_id } });
    return response?.data?.result || [];
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

// Get recent (yesterday + today) notifications for a user
export const getRecentNotifications = async (user_id: string) => {
  try {
    const response = await apiClient.get(`${baseURL}/notifications/recent`, { params: { user_id } });
    return response?.data?.result || [];
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

// Mark a single notification as read
export const markNotificationRead = async (notification_id: string) => {
  try {
    const response = await apiClient.patch(`${baseURL}/notifications/${notification_id}/read`);
    return response?.data?.result;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

// Mark all displayed notifications as read for a user
export const markAllNotificationsRead = async (user_id: string) => {
  try {
    const response = await apiClient.patch(`${baseURL}/notifications/read-all`, { user_id });
    return response?.data?.result;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

// Clear (dismiss) a single notification
export const clearNotification = async (notification_id: string) => {
  try {
    const response = await apiClient.patch(`${baseURL}/notifications/${notification_id}/clear`);
    return response?.data?.result;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

// Clear (dismiss) all displayed notifications for a user
export const clearAllNotifications = async (user_id: string) => {
  try {
    const response = await apiClient.patch(`${baseURL}/notifications/clear-all`, { user_id });
    return response?.data?.result;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};






